export const APP_NAME: string = process.env.REACT_APP_NAME ?? 'Undefined_App';
export const RMS_SERVICE_NAME: string = process.env.REACT_APP_RMS_SERVICE_NAME ?? 'unknown-app';
export const RMS_ENV = process.env.REACT_APP_RMS_ENV as 'non-prod' | 'prod';
export const ALLOWED_USERS: string[] = process.env.REACT_APP_ALLOWED_USERS?.split(',') ?? [];
